// extracted by mini-css-extract-plugin
export default {"container":"Si-z","bubbleNav":"Ti-z","graphic":"Ui-z","contact":"Vi-z"};